/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface Account {
  /**
   * Agent language is the language used by the agents to respond to customers.
   * This will be the language of translation when a customer talks to an agent.
   */
  agent_language?: string;
  automation_settings?: AccountAutomationSettings;
  country?: string;
  /** @format date-time */
  created_at?: string;
  currency?: string;
  daily_digest_enabled?: boolean;
  /**
   * Daily Digest Timestamp
   * @format date-time
   */
  daily_digest_last_sent_at?: string;
  domain?: string;
  /** Feature Flags */
  faq_enabled?: boolean;
  hours?: AccountHours;
  /** @format uuid */
  id?: string;
  is_https?: boolean;
  /**
   * Language is the language used in the website.
   * This is the default language of the widget UI on the website.
   */
  language?: string;
  logo_url?: string;
  /** Maturity State */
  maturity_state?: string;
  /** @format date-time */
  maturity_state_changed_at?: string;
  myshopify_domain?: string;
  name?: string;
  /** Billing */
  plan_code?: string;
  /** Description shown to their customers */
  public_description?: string;
  /** Online hours */
  show_hours?: boolean;
  slug?: string;
  support_email?: string;
  timezone?: string;
  /** @format date-time */
  trashcan_emptied_at?: string;
  /** @format date-time */
  trial_until?: string;
  /** @format date-time */
  updated_at?: string;
  usage?: AccountUsage;
  usage_reset_notification_enabled?: boolean;
  website_details?: AccountWebsiteDetails;
}

export interface AccountAutomationSettings {
  autosend_abandoned_cart?: boolean;
  autosend_follow_up_sales?: boolean;
  autosend_proactive_sales?: boolean;
  autosend_product_education?: boolean;
  autosend_question?: boolean;
  autosend_request_feedback?: boolean;
  autosend_shipping?: boolean;
  autosend_welcome?: boolean;
  bot_context_form?: AccountBotContextForm;
}

export interface AccountBotContextForm {
  discount_code_abandoned_carts?: string;
  discount_code_follow_up_sales?: string;
  discount_code_new_customers?: string;
  faq?: string;
  recommendation?: string;
  store_explanation?: string;
}

export interface AccountHours {
  friday_end?: string;
  friday_start?: string;
  monday_end?: string;
  monday_start?: string;
  saturday_end?: string;
  saturday_start?: string;
  sunday_end?: string;
  sunday_start?: string;
  thursday_end?: string;
  thursday_start?: string;
  tuesday_end?: string;
  tuesday_start?: string;
  wednesday_end?: string;
  wednesday_start?: string;
}

export interface AccountUsage {
  /** @format uint64 */
  autosent?: number;
  /** @format uint64 */
  email_sent?: number;
  /** @format uint64 */
  facebook_sent?: number;
  /** @format uint64 */
  flags_assigned?: number;
  /** @format uint64 */
  instagram_sent?: number;
  /** @format date-time */
  last_usage_reset_at?: string;
  /** @format uint64 */
  messages_written_by_ai?: number;
  /** @format uint64 */
  sms_sent?: number;
  /** @format uint64 */
  whatsapp_sent?: number;
  /** @format uint64 */
  widget_sent?: number;
  /** @format uint64 */
  workflow_assigned?: number;
}

export interface AccountWebsiteDetails {
  background_color?: string;
  button_background_color?: string;
  button_background_secondary_color?: string;
  button_text_color?: string;
  language?: string;
  logo?: string;
  text_color?: string;
  text_content?: string;
  widget_icon_pattern?: string;
  widget_icon_url?: string;
  widget_position?: string;
}

/** A request object for the account creation endpoint. */
export interface CreateAccountRequest {
  attribution?: string;
  country?: string;
  currency?: string;
  email?: string;
  full_name?: string;
  is_website_https?: boolean;
  myshopify_domain?: string;
  password?: string;
  shopify_access_token?: string;
  shopify_id?: string;
  support_email?: string;
  thumbnail_url?: string;
  timezone?: string;
  website_domain?: string;
  website_name?: string;
}

export interface Model {
  /** @format date-time */
  created_at?: string;
  /** @format uuid */
  id?: string;
  /** @format date-time */
  updated_at?: string;
}

export interface User {
  accounts?: Account[];
  /** @format date-time */
  created_at?: string;
  email?: string;
  full_name?: string;
  /** @format uuid */
  id?: string;
  thumbnail_url?: string;
  /** @format date-time */
  updated_at?: string;
}

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "https://api.talkvisor.com/v1" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Talkvisor API
 * @baseUrl https://api.talkvisor.com/v1
 *
 * This is a set of RESTful endpoints used by app and widget.
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v1 = {
    /**
     * @description This will create a new account if not exists, and sign in as the account.
     *
     * @name CreateAccount
     * @summary Create or update an account and sign in as the account.
     * @request POST:/v1/accounts
     * @secure
     */
    createAccount: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/v1/accounts`,
        method: "POST",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name GetAccount
     * @summary Get info of an account. `me` as :id to get the current user's account.
     * @request GET:/v1/accounts/:id
     * @secure
     */
    getAccount: (id: string, params: RequestParams = {}) =>
      this.request<Account, any>({
        path: `/v1/accounts/${id}`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint returns the total number of orders associated with the current user's account.
     *
     * @name GetOrderCount
     * @summary Get the order count for the current user's account.
     * @request GET:/v1/accounts/order-count
     * @secure
     */
    getOrderCount: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/v1/accounts/order-count`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Autocomplete based on the given query
     *
     * @name Autocomplete
     * @request GET:/v1/autocomplete
     * @secure
     */
    autocomplete: (
      query: {
        /** @format string */
        q: string;
        /** @format string */
        conversation_status?: string;
        /** @format string */
        workflow?: string;
        /** @format string */
        workflow_not?: string;
        /** @format string */
        customer_journey_after?: string;
        /** @format string */
        customer_journey?: string;
        /** @format string */
        livechat?: string;
        /** @format string */
        show_hidden?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/v1/autocomplete`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name GetUser
     * @summary Get info of a user. `me` as :id to get the current user.
     * @request GET:/v1/users/:id
     * @secure
     */
    getUser: (id: string, params: RequestParams = {}) =>
      this.request<User, any>({
        path: `/v1/users/${id}`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
